import React, { Component, useEffect, useState } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { publishCountToCSM } from "./overview/utils/utils";
import Overview from "./overview/Overview";
import Overviewv2 from "./overview/Overviewv2";
import Overviewv3 from "./overview/Overviewv3";
import OutboundOverviewAMZL from "./outboundAmzl/OutboundOverviewAMZL";
import Settings from "./settings/Settings";
import Settingsv2 from "./settings/settingsv2/Settings";
import OutboundOverviewRoot from "./outboundOverview/OutboundOverviewRoot";
import Labs from "./labs/Labs";
import { DeviceLayoutProvider } from "./common/context/DeviceLayoutContext";
import { metricProcessName } from "./util/Constants";
import DolphinVerification from "./dolphinVerification/DolphinVerification";
import blueDarkTokens from "@amzn/meridian-tokens/theme/blue-dark";
import blueLightTokens from "@amzn/meridian-tokens/theme/blue-light";
import Theme from "@amzn/meridian/theme";
import {
  getDarkModeStatus,
  setDarkModeStateListener,
} from "./handler/ParentDataHandler";
import { AlchemyAnalytics } from "@amzn/alchemy-components/dist/utils/AlchemyAnalytics.es5.js";
import { getStationCode } from "./network/NetworkUtil";
import { getUserName } from "./resources/EmployeeResource";
import Overviewv4 from "./overview/Overviewv4";
import RouteStatus from "./RouteStatus/RouteStatus";

function publishRoutePath(location) {
  const metricName = location.pathname;
  publishCountToCSM({
    processName: metricProcessName,
    metricName: metricName,
  });
}

const AppComponent = () => {
  const [currentDarkMode, setCurrentDarkMode] = useState("light");

  useEffect(() => {
    setDarkModeStateListener(setCurrentDarkMode);
    getDarkModeStatus();

    const asyncFunc = async () => {
      const visitorId = await getUserName();
      new AlchemyAnalytics({
        apikey: "ae299fdb-5276-403c-4b78-dd8b69d722d7",
        account: {
          id: "SCC - AMZL",
        },
        visitor: {
          id: visitorId,
          stationCode: getStationCode(),
        },
      });
    };

    asyncFunc();
  }, []);

  return (
    <Theme
      tokens={currentDarkMode === "dark" ? blueDarkTokens : blueLightTokens}
    >
      <DeviceLayoutProvider>
        <Switch>
          <Route path="/overview" component={Overview} />
          <Route path="/overviewv2" component={Overviewv2} />
          <Route path="/overviewv3" component={Overviewv3} />
          <Route path="/mySCC" component={Overviewv4} />
          {/* Below predicate decides whether to show new AR experience or current AR experience */}
          <Route path="/outbound" component={OutboundOverviewRoot} />
          <Route path="/outboundAmzl" component={OutboundOverviewAMZL} />
          <Route path="/settings" component={Settings} />
          <Route path="/settingsv2" component={Settingsv2} />
          <Route path="/labs" component={Labs} />
          <Route path="/dolphinVerification" component={DolphinVerification} />
          <Route path="/routestatus/:context" component={RouteStatus} />
          <Route path="/routestatus" component={RouteStatus} />
        </Switch>
      </DeviceLayoutProvider>
    </Theme>
  );
};

class App extends Component {
  componentWillMount() {
    publishRoutePath(this.props.location);
    this.onRouteSwitch = this.props.history.listen(() => {
      publishRoutePath(this.props.location);
    });
  }

  componentWillUnmount() {
    this.onRouteSwitch();
  }

  render() {
    return <AppComponent />;
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/app.js